import React from 'react';
import styled from 'styled-components';
import { Icon } from 'dlweb-components';

const DropOverlay = ({visible, folderName}) => {

  return (
    <Container visible={visible}>
      <MessageContainer>
        <Icon type="upload" style={{marginRight: '10px'}} />
        <div>
          Drop files to upload them to
          <span style={{fontWeight: '500'}}> {folderName}</span>
        </div>
      </MessageContainer>
    </Container>
  )
}

const Container = styled.div`
  display: ${p => p.visible ? 'block' : 'none'};
	position: absolute;
  bottom: 160px;
  left: 50%;
  width: 600px;
  margin-left: -300px;
  text-align: center;
  z-index: 9999;
`
const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--primary-dark);
  color: #fff;
  text-align: left;
  padding: 15px;
  z-index: 9999;
  border-radius: 10px;
`

export default DropOverlay;